module.exports = __webpack_public_path__ + "static/img/product1.e62855f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product1.png
// module id = YHMn
// module chunks = 1